import React from 'react'
import { sourceSearchTooltip } from '@chegg-wt/core/utils/searchSourcesMap'
import {
  searchPageRegion,
  Region,
} from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { SEARCH_BOTTOM } from '@chegg-wt/core/utils/searchSources'
import { SourceType } from '@chegg-wt/core/types/core'
import SourceToolTip from '../Tooltip/SourceTooltip'
import { MANUAL_CITE_LINK } from './utils/testIds'
import WorldCatLink from './WorldCatLink'
import * as Styled from './styled'

const MANUAL_CITE_LINK_COPY = 'Create manual citation'

export interface SearchBottomContentProps {
  isWorldCatSource: boolean
  onManualCiteClick: (region: Region) => void
  sourceType: SourceType
}

const SearchBottomContent: React.FC<SearchBottomContentProps> = ({
  isWorldCatSource,
  onManualCiteClick,
  sourceType,
}) => {
  const sourceTooltip = sourceSearchTooltip[sourceType?.id] && (
    <>
      <Styled.SeparatorPipe>|</Styled.SeparatorPipe>
      <SourceToolTip sourceType={sourceType} location={SEARCH_BOTTOM} />
    </>
  )

  return (
    <Styled.BottomContainer>
      <Styled.SearchHelperLeft>
        <Styled.SearchHelperLink
          onClick={() => onManualCiteClick(searchPageRegion)}
          data-test={MANUAL_CITE_LINK}
        >
          {MANUAL_CITE_LINK_COPY}
        </Styled.SearchHelperLink>

        {sourceTooltip}
      </Styled.SearchHelperLeft>

      {isWorldCatSource && (
        <Styled.WorldCatDesktop>
          <WorldCatLink />
        </Styled.WorldCatDesktop>
      )}
    </Styled.BottomContainer>
  )
}

export default SearchBottomContent
